import { ParsedUrlQuery } from 'querystring'
import theme, { SupportedTheme } from '../theme'
import { isSmava } from './getTenantInfo.utils'

export const customizeTheme = (
  themeName: SupportedTheme,
  queryParams: ParsedUrlQuery,
) => {
  theme.name = themeName
  theme.components = {
    ...theme.components,
    // ANCH-1357: Need to invert secondary and primary color of CTA's for FC client
    ...(!isSmava &&
      queryParams?.version === 'v2' && {
        MuiButton: {
          styleOverrides: {
            contained: {
              backgroundColor: theme.palette.secondary.main,
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
              },
              color: theme.palette.primary.contrastText,
            },
          },
        },
      }),
  }

  if (queryParams?.palette) {
    theme.palette = {
      ...theme.palette,
      ...getPaletteFromQueryParams(queryParams?.palette as string),
    }
  }
}

export const getPaletteFromQueryParams = (palette: string) => {
  try {
    return JSON.parse(palette)
  } catch (ex) {}

  return {}
}
